import { useState, useEffect } from 'react';
import DealCard from '../../../UI/DealCard/DealCard';
import { supabase } from '../../../../api';
import { Box, Grid, Typography, Paper, Link } from '@mui/material';

const Body = ({ user }) => {
  let [deals, setDeals] = useState();

  useEffect(
    () => {
      fetchDeals();
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const fetchDeals = async () => {
    let { data: deals, error } = await supabase.from('deals').select('*');
    if (error) console.log(error);
    else setDeals(deals);
  };

  if (deals === undefined) {
    return <Typography>Still loading...</Typography>;
  }

  return (
    <Box sx={{ mt: '3rem' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          mt: '3rem',
        }}>
        {user.membershipLevel !== 'member' && user.membershipLevel !== 'member+mentor' && (
          <Link
            href='/payments'
            style={{
              width: '100%',
              textDecoration: 'none',
              cursor: 'pointer',
            }}>
            <Paper
              elevation={20}
              sx={{
                p: '2px 4px',
                mb: '2rem',
                width: '100%',
                backgroundColor: 'primary.main',
              }}>
              <Typography
                sx={{
                  ml: 1,
                  p: '10px',
                  color: 'white',
                }}>
                Apply to become a member of The 100 Club for access »
              </Typography>
            </Paper>
          </Link>
        )}
        <Grid container alignItems='stretch' sx={{ mt: '3rem' }}>
          {deals.map((deal) => {
            return (
              <DealCard
                key={deal.id}
                partnerLogo={deal.partnerLogo}
                partnerName={deal.partnerName}
                partnerBenefits={deal.partnerBenefits}
                id={deal.id}
                membershipLevel={user.membershipLevel}
              />
            );
          })}
        </Grid>
      </Box>
    </Box>
  );
};

export default Body;
